import clsx from 'clsx';
import { FC } from 'react';
import React from 'react';
import { useCallback } from 'react';
import { IconDown } from './IconDown.js';
import styles from './SortOrderSwitch.module.scss';

const ASC_STATE = 1;
const DESC_STATE = -1;

export interface Props {
  value: number;
  onChange: (value: number) => void;
  className: string;
}

export const SortOrderSwitch: FC<Props> = ({ value, onChange, className }) => {
  const isDesc = value < 0;
  const isAsc = value > 0;

  const handleChange = useCallback(() => {
    if (isDesc) {
      onChange(ASC_STATE);
    } else {
      onChange(DESC_STATE);
    }
  }, [onChange, isDesc]);

  return (
    <span className={clsx(styles.select, className)} onClick={handleChange}>
      <IconDown flip={isAsc} />
    </span>
  );
};
